import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../../../components/SettingsBreadcrumb';
import './inserir-modelo-4.scss';
import BibliotecaModal from '../../BibliotecaModal/BibliotecaModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Image,
  IconButton,
  Select,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import * as api from '../../../../../../api/outrasPaginas';
import Swal from 'sweetalert2';
import { FaImage, FaTimes, FaEye } from 'react-icons/fa';

interface Imagem {
  id: number;
  imagem: string;
  imagemPreview: string;
  posicaoImagem: string;
  tipo?: 'image' | 'video';
}

interface Secao {
  id: number;
  aberto: boolean;
  imagem: Imagem[];
}

const InserirPaginaModelo4: React.FC = () => {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    dscUrl: { value: string; error: boolean };
  }>({
    titulo: { value: '', error: false },
    dscUrl: { value: '', error: false },
  });

  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [submitAttempted, setSubmitAttempted] = useState<boolean>(false);
  const [bibliotecaOpen, setBibliotecaOpen] = useState<boolean>(false);
  const [secaoAtualId, setSecaoAtualId] = useState<number | null>(null);

  const [selecao, setSelecao] = useState<Secao[]>([
    {
      id: 1,
      aberto: true,
      imagem: []
    },
  ]);

  const {
    isOpen: isPreviewAberto,
    onOpen: onPreviewAberto,
    onClose: onPreviewFechado
  } = useDisclosure()

  const [listaPosicaoImagem, setListaPosicaoImagem] = useState<
    { codPropriedade: number; dscPropriedade: string }[]
  >([]);
  const videoExts = ['.mp4', '.webm', '.ogg'];

  useEffect(() => {
    api.listarPosicaoImagem()
      .then(data => {
        setListaPosicaoImagem(data);
      })
      .catch(err => {
        console.error("Erro ao listar posições de imagem", err);
      });
  }, []);

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const isFormValid = () => {
    const { titulo, dscUrl } = formValues;
    if (!titulo.value.trim() || !dscUrl.value.trim()) return false;
    const isValido =
      selecao.length > 0
    return isValido;
  };

  const formataData = (date: Date) => {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  };

  const abrirBlibliotecaDeFotos = (secaoId: number) => {
    setSecaoAtualId(secaoId);
    setBibliotecaOpen(true);
  };

  const handleSelectImageFromBiblioteca = (media: any) => {
    if (secaoAtualId == null) return;
    const url = decodeURIComponent(media.dscUriCdn || media.dscMidia);
    const limpar = url.split('?')[0].toLowerCase();
    const isVideo = videoExts.some(ext => limpar.endsWith(ext));

    const nova: Imagem = {
      id: Date.now(),
      imagem: url,
      imagemPreview: url,
      posicaoImagem: '',
      tipo: isVideo ? 'video' : 'image'
    };

    setSelecao(prev =>
      prev.map(secao =>
        secao.id === secaoAtualId
          ? { ...secao, imagem: [...secao.imagem, nova] }
          : secao
      )
    );
    setBibliotecaOpen(false);
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setLoadingButton(true);

    let fotoSemPosicaoSelecionada = false;
    for (const secao of selecao) {
      for (const img of secao.imagem) {
        if (img.imagem && !img.posicaoImagem) {
          fotoSemPosicaoSelecionada = true;
          break;
        }
      }
      if (fotoSemPosicaoSelecionada) break;
    }
    if (fotoSemPosicaoSelecionada) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Selecione uma opção para a posição de todas as imagens.',
        confirmButtonText: 'OK'
      });
      setLoadingButton(false);
      return;
    }

    try {
      const updatedSelecao = selecao.map(secao => ({
        ...secao,
        imagem: secao.imagem.map(img => {
          const posicao = listaPosicaoImagem.find(option =>
            option.codPropriedade.toString() === img.posicaoImagem
          );
          return {
            id: img.id,
            url: img.imagem,
            codPropriedade: posicao ? posicao.codPropriedade : null,
            dscPropriedade: posicao ? posicao.dscPropriedade : null,
          };
        })
      }));

      const jsonModeloData = {
        codModeloPagina: 4,
        tituloGeral: formValues.titulo.value,
        imagens: selecao.map(secao => ({
          imagem: updatedSelecao.find(s => s.id === secao.id)?.imagem || []
        }))
      };

      const params = {
        nomPagina: formValues.titulo.value || null,
        dscUrl: formValues.dscUrl.value || null,
        datRegistro: formataData(new Date()),
        txtHtml: null,
        numHtmlProprio: 0,
        numBloqueada: 0,
        sitRegistro: 1,
        datInativo: null,
        codModeloPagina: 4,
        jsonModelo: JSON.stringify(jsonModeloData)
      };

      await api.inserirPagina(params);
      setLoadingButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Página inserida com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente/outras-paginas');
      });
    } catch (error) {
      console.error('Erro ao inserir página:', error);
      if (typeof error === 'string' && error.includes('Erro ao atualizar a Pagina')) {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'O nome da página já está em uso. Por favor, escolha outro.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'Erro ao inserir página. Tente novamente mais tarde.',
          confirmButtonColor: '#1789FC',
          confirmButtonText: 'OK',
        });
      }
      setLoadingButton(false);
    }
  };

  const handleRemoveImagem = (secaoId: number, imgId: number) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.filter(img => img.id !== imgId) }
          : secao
      )
    );
  };

  const handleAtualizarPosicaoImagem = (secaoId: number, imgId: number, posicaoImagem: string) => {
    setSelecao(prevSelecao =>
      prevSelecao.map(secao =>
        secao.id === secaoId
          ? { ...secao, imagem: secao.imagem.map(img => img.id === imgId ? { ...img, posicaoImagem } : img) }
          : secao
      )
    );
  };

  const carregarPreview = () => {
    const todasImagens = selecao.flatMap(secao => secao.imagem.map(img => ({
      ...img,
      ordem:
        listaPosicaoImagem.find(p => p.codPropriedade.toString() === img.posicaoImagem)?.dscPropriedade?.toLowerCase() || 'centro'
    })));

    const esquerda = todasImagens.filter(i => i.ordem.includes('esquerda'));
    const centro = todasImagens.filter(i => i.ordem.includes('centro') || !i.ordem);
    const direita = todasImagens.filter(i => i.ordem.includes('direita'));

    const ordenadas = [...esquerda, ...centro, ...direita];

    return (
      <Box px={[4, 10]} py={8} maxW="1200px" mx="auto">
        <Heading as="h2" fontSize="2xl" color="#004a7f" mb={8} textAlign="center">
          {formValues.titulo.value}
        </Heading>

        <Flex justify="center" wrap="wrap" gap={6}>
          {ordenadas.map((img) => (
            <Box
              key={img.id}
              maxW="300px"
              w="100%"
              borderRadius="lg"
              boxShadow="md"
              overflow="hidden"
              bg="#f4f4f4"
              position="relative"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p="4"
            >
              {img.tipo === 'video' ? (
                <video
                  src={img.imagemPreview}
                  controls
                  muted
                  playsInline
                  style={{
                    maxWidth: '100%',
                    maxHeight: '300px',
                    objectFit: 'contain',
                    border: '2px solid #ccc',
                    borderRadius: '8px'
                  }}
                />
              ) : (
                <Image
                  src={img.imagemPreview}
                  alt="Mídia"
                  maxW="100%"
                  maxH="300px"
                  objectFit="contain"
                  border="1px solid #ccc"
                  borderRadius="8px"
                />
              )}
            </Box>
          ))}
        </Flex>
      </Box>
    );
  };

  return (
    <Flex direction="column" padding="40px" backgroundColor="#fafafa" width="100%" height="100%" overflow="hidden">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Modelo 4 - Mídia Livre
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row mb-3">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Título Geral</FormLabel>
                <CustomInput
                  placeholder="Digite um título"
                  value={formValues.titulo.value}
                  maxLength={100}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.dscUrl.error}>
                <FormLabel mb="8px">URL da Página</FormLabel>
                <CustomInput
                  placeholder="Digite uma URL"
                  value={formValues.dscUrl.value}
                  onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
                  maxLength={512}
                />
              </FormControl>
            </div>
          </div>

          <Box mb="20px">
            {selecao.map((secao, index) => {
              const secaoErro = !secao.aberto && submitAttempted && secao.imagem.some(img => img.imagem && !img.posicaoImagem);
              return (
                <Box
                  key={secao.id}
                  borderWidth="1px"
                  borderRadius="md"
                  p="20px"
                  mb="10px"
                  borderColor={secaoErro ? 'red.500' : 'gray.200'}
                >
                  {secao.aberto && (
                    <Box>
                      <FormControl mb="10px">
                        <Flex wrap="wrap" gap="20px">
                          {secao.imagem.map(img => (
                            <Box key={img.id} borderWidth="1px" borderRadius="md" p="10px" bg="#FFF" boxShadow="md" position="relative">
                              <Box w="150px" h="100px" bg="#f0f0f0" borderRadius="4px" overflow="hidden" mx="auto">
                                {img.tipo === 'video' ? (
                                  <video src={img.imagemPreview} controls muted playsInline style={{ width: '100%', height: '100%', objectFit: 'contain' }} onClick={e => e.stopPropagation()} />
                                ) : (
                                  <Image src={img.imagemPreview} alt="Preview" w="100%" h="100%" objectFit="contain" onClick={e => e.stopPropagation()} />
                                )}
                              </Box>
                              <IconButton icon={<FaTimes />} size="xs" colorScheme="red" position="absolute" top="2" right="2" borderRadius="full" aria-label="Remover" onClick={e => { e.stopPropagation(); handleRemoveImagem(secao.id, img.id) }} />
                              <Select mt="10px" value={img.posicaoImagem} onChange={e => handleAtualizarPosicaoImagem(secao.id, img.id, e.target.value)}>
                                <option value="" disabled>Posição</option>
                                {listaPosicaoImagem.map(opt => <option key={opt.codPropriedade} value={opt.codPropriedade}>{opt.dscPropriedade}</option>)}
                              </Select>
                            </Box>
                          ))}

                          <Button
                            variant="outline"
                            onClick={() => abrirBlibliotecaDeFotos(secao.id)}>
                            <FaImage color="gray" size="15px" />
                            <Text pl="6px" mt="4px" fontSize="sm">
                              Adicionar Mídia
                            </Text>
                          </Button>
                        </Flex>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>

          <Flex mt="35px" justifyContent="end">
            <Button m="6px" onClick={() => navigate('/cms/edicao-cidade-inteligente/outras-paginas')}>
              Desistir
            </Button>
            <Button
              mt="6px"
              leftIcon={<FaEye />}
              variant="outline"
              onClick={onPreviewAberto}
            >
              Ver Preview
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Inserindo..."
            >
              Inserir Página Modelo
            </Button>
          </Flex>
        </form>
      </Box>
      <BibliotecaModal
        isOpen={bibliotecaOpen}
        onClose={() => setBibliotecaOpen(false)}
        onSelectImage={handleSelectImageFromBiblioteca}
      />

      <Modal isOpen={isPreviewAberto} onClose={onPreviewFechado} size="full" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={'#004a7f'} fontWeight={'bold'}></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {carregarPreview()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onPreviewFechado}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default InserirPaginaModelo4;
